import styled from 'styled-components';
import { Box, HStack } from '../Core';

export const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.gray['100']};
  align-self: center;
  white-space: nowrap;
`;
Wrapper.defaultProps = {
  py: 0,
  px: 'spacing4',
};

export const Currency = styled(HStack)`
  font-size: ${({ theme }) => theme.fontSizeDefault}rem;
  color: ${({ theme }) => theme.colors.gray['100']};
  & > svg {
    // pixel perfect
    margin-top: -0.1em;
    margin-right: ${({ theme }) => theme.spacing4}px;
  }

  & > span {
    line-height: 1;
  }

  &:first-child {
    margin-right: ${({ theme }) => theme.spacing8}px;
  }
`;

export const DisplaySecurityWrapper = styled(Wrapper)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;
